<template>
  <div selenium="Upload-Photo-Button">
    <label v-if="canUploadFiles" class="btn-secondary w-100">
      <vk-icon name="camera" class="m-r-1" size="20"/>
      <input
          accept="image/*"
          class="d-none"
          multiple
          type="file"
          @change="upload">
      Add Photos
    </label>

    <special-message ref="file-size-error" type="error" class="m-t-2">
      File size cannot exceed {{ maxFileSize / 1000000 }}MB
    </special-message>

    <special-message ref="file-type-error" type="error" class="m-t-2">
      Please upload a file in one of these formats: JPG, GIF, PNG.
    </special-message>

    <!-- Image Preview Container -->
    <div class="d-flex flex-wrap m-t-2">
      <div v-if="loadingFile" class="LOADING-FILE">
        <spinner/>
      </div>
      <gallery v-if="value.length" :files="value" deletable @deleteImage="deleteImage"/>
    </div>
    <image-popup
        :isOpen="isShowImagePopup"
        @close= "isShowImagePopup=false"/>
  </div>
</template>

<script>
import _get from 'lodash/get';
import http from '@homeservices/api-kit/axios';
import { uploadAsset, deleteAsset } from '@homeservices/api-kit/asset';
import Gallery from '@/components/Gallery';
import SpecialMessage from '@/components/SpecialMessage';
import ImagePopup from '@/components/ServicesPricing/ImagePopup';

import {
  VALID_IMAGE_TYPES,
  VALID_IMAGE_ACCEPT_TYPES,
  DEFAULT_MAX_IMAGE_SIZE,
} from '@/constants';


export default {
  name: 'image-upload',
  components: {
    Gallery,
    SpecialMessage,
    ImagePopup,
  },
  props: {
    maxFileCount: {
      type: Number,
      default: 15,
    },
    maxFileSize: {
      type: Number,
      default: DEFAULT_MAX_IMAGE_SIZE,
    },
    namespace: {
      type: String,
      default: 'work-orders-private-msg',
    },
    groupId: {
      type: String,
      default: 'rsf-image-upload',
    },
    value: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      loadingFile: false,
      isShowImagePopup: false,
    };
  },
  computed: {
    canUploadFiles () {
      return this.value.length < this.maxFileCount;
    },
  },
  methods: {
    deleteImage (id) {
      deleteAsset(this.namespace, id).then(() => this.$emit('input', this.value.filter((file => file.id !== id))));
    },
    async upload (event) {
      this.$refs['file-size-error'].hide();
      const files = Object.values(_get(event, 'target.files')) || Object.values(_get(event, 'dataTransfer.files'));
      if (!files.length) {
        return;
      }

      // input accept attribute should only allow uploading of image types
      // but that is up to the browser so we still check it just in case.
      if (files.length <= 8) {
        files.forEach(async (file) => {
          if (VALID_IMAGE_TYPES.indexOf(file.type) < 0) {
            return this.$refs['file-type-error'].trigger(5000);
          }

          if (file.size > this.maxFileSize) {
            return this.$refs['file-size-error'].trigger(5000);
          }

          this.loadingFile = true;

          try {
            const formData = new FormData();
            formData.append('file', file);
            const { data } = await uploadAsset(this.namespace, this.groupId, formData);
            // TODO: Remove this get request when DAS fixes the upload API
            const { data: { results: [result] } } = await http.get(`/platform/coreassets/r/assets/images/v1?url=${data.url}`);
            data.id = result.id;
            this.$emit('input', [...this.value, data]);
          } catch (error) {
            console.error(error); // eslint-disable-line no-console
          }
        });
      } else {
        this.isShowImagePopup = true;
      }
      this.loadingFile = false;
    },
  },
  VALID_IMAGE_ACCEPT_TYPES,
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.LOADING-FILE {
  @include unit(width height, 6, 10);
  @include margin-right(1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: $color-gray80;
}
</style>
